'use client'

import { useTranslations } from 'next-intl'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'

import type { FC } from 'react'

const SeeMoreButton: FC<{ starterSize: number }> = ({ starterSize }) => {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const t = useTranslations('Buttons')

  const clickHandler = () => {
    const currentParams = new URLSearchParams(searchParams.toString())
    currentParams.set('page_size', starterSize + 3 + '')
    router.push(pathname + '?' + currentParams.toString(), {
      scroll: false,
    })
  }

  return (
    <div className="mt-8 flex justify-center">
      <button
        type="button"
        className="btn-primary mx-auto"
        aria-label={t('ShowMore')}
        onClick={clickHandler}
      >
        {t('ShowMore')}
      </button>
    </div>
  )
}

export default SeeMoreButton
